<groundworks-card [cardClasses]="['shadow-none', 'h-100']">
  <groundworks-card-body [cardBodyClasses]="['d-flex', 'flex-column', 'h-100', 'p-4']">
    <div class="d-flex flex-column flex-grow-1 overflow-auto" style="min-height: 0;">
      <h2 class="card-title h5 mb-3">Sales Approval Checklist</h2>
      <div class="table-responsive pb-2">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Required Items</th>
            <th>System Verified</th>
            <th>Manager Verified</th>
          </tr>
          </thead>
          <tbody>
            @for (item of tableData(); track item.id) {
              <tr>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  <input type="checkbox" class="form-check-input" [checked]="item.systemVerified" disabled/>
                </td>
                <td>
                  <input type="checkbox" class="form-check-input" id="manager-verified-{{ item.id }}"
                         [checked]="item.managerVerified" [disabled]="isCheckboxDisabled()"
                         (change)="onCheckboxChange(item.flagValue, $event)"/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button [disabled]="isDisabled()" class="btn btn-primary" id="approve-button" (click)="approveSale()">Approve
        Sale
      </button>
    </div>
  </groundworks-card-body>
</groundworks-card>
